import React from "react";
import { Typography } from "antd";
import type { Booking } from "../../types/booking";
import { getPrimaryCommercialInvoicePath } from "../../features/commercialInvoiceAnalysis/commercialInvoiceAnalysisService";
import {
  bookingHasCurrentCiAnalysis,
} from "../../utils/agentBookingCiAnalysis";
import { getValidityBreakdownFromBooking } from "../../features/commercialInvoiceAnalysis/commercialInvoiceValidity";
import { CommercialInvoiceValidityCellContent } from "../../features/commercialInvoiceAnalysis/CommercialInvoiceValidityDisplay";

const { Text } = Typography;

interface AgentCiValidityCellProps {
  booking: Booking;
}

export const AgentCiValidityCell: React.FC<AgentCiValidityCellProps> = ({
  booking,
}) => {
  const primaryPath = getPrimaryCommercialInvoicePath(booking.commercial_invoice_file);
  if (!primaryPath) {
    return <Text type="secondary">—</Text>;
  }

  if (!bookingHasCurrentCiAnalysis(booking)) {
    return <Text type="secondary">—</Text>;
  }

  const breakdown = getValidityBreakdownFromBooking(booking);
  if (!breakdown) {
    return <Text type="secondary">—</Text>;
  }

  return <CommercialInvoiceValidityCellContent breakdown={breakdown} />;
};
